import { Link } from "react-router-dom";

import { Box, Group, Text } from "@mantine/core";

type Props = {
  showWordmark?: boolean;
};

const HeaderLogo: React.FC<Props> = ({ showWordmark = true }) => {
  return (
    <Group
      renderRoot={(props) => (
        <Link to="/" aria-label="Villa Braou - home" {...props} />
      )}
      gap="xs"
      wrap="nowrap"
      style={{ textDecoration: "none" }}
    >
      <Box
        style={{
          width: 44,
          height: 44,
          flexShrink: 0,
          display: "grid",
          placeItems: "center",
        }}
      >
        <img
          src="/logo-square.png"
          alt=""
          style={{ width: "100%", height: "100%", objectFit: "contain" }}
        />
      </Box>
      {showWordmark && (
        <Box visibleFrom="xs">
          <Text
            ff='"Fraunces", Georgia, serif'
            fz="lg"
            fw={600}
            lh={1}
            c="sea.6"
            style={{ letterSpacing: "0.02em" }}
          >
            Villa Braou
          </Text>
          <Text fz="xs" c="dimmed" mt={2}>
            Rodakino · South Crete
          </Text>
        </Box>
      )}
    </Group>
  );
};

export default HeaderLogo;
